import { Component, Output, EventEmitter } from '@angular/core';
import { CoreFacade } from '@app/store/core/core.facade';

@Component({
  selector: 'app-rc-dialog-wrapper',
  templateUrl: './rc-dialog-wrapper.component.html',
  styleUrls: ['./rc-dialog-wrapper.component.scss'],
})
export class RcDialogWrapperComponent {
  @Output() closePopin = new EventEmitter();

  showPopinLoader$ = this.coreFacade.showPopinLoader$;

  constructor(private coreFacade: CoreFacade) {}

  close(event: MouseEvent): void {
    event.preventDefault();
    this.closePopin.emit();
  }
}
